import Swiper, { Navigation, Pagination } from 'swiper';
import { carousel, carouselOverlay } from './carousel';

Swiper.use([Navigation, Pagination]);

export const carouselInstances = () => {
    const carouselList = [...document.querySelectorAll('.swiper-container')];
    const carouselListOverlay = [
        ...document.querySelectorAll('.swiper-container-overlay'),
    ];

    if (carouselList) {
        for (let i = 0; i < carouselList.length; i += 1) {
            // find only the buttons within the parent Swiper node
            const btnPrev = carouselList[i].parentNode.querySelector(
                '.swiper-button-prev'
            );
            const btnNext = carouselList[i].parentNode.querySelector(
                '.swiper-button-next'
            );
            carousel(
                `.swiper-container[data-carouselid="${carouselList[i].dataset.carouselid}"]`,
                btnNext, // '.swiper-button-next',
                btnPrev // '.swiper-button-prev'
            );
        }
    }
    if (carouselListOverlay) {
        for (let i = 0; i < carouselListOverlay.length; i += 1) {
            carouselOverlay(
                `.swiper-container-overlay[data-carouselid="${carouselListOverlay[i].dataset.carouselid}"]`,
                '.swiper-button-next',
                '.swiper-button-prev'
            );
        }
    }
};
